import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M9 2v17.5A2.5 2.5 0 0 1 6.5 22v0A2.5 2.5 0 0 1 4 19.5V2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M20 2v17.5a2.5 2.5 0 0 1-2.5 2.5v0a2.5 2.5 0 0 1-2.5-2.5V2",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M3 2h7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 2h7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9 16H4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20 16h-5", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "TestTubes";
const TestTubes = memo(themed(Icon));
export {
  TestTubes
};
//# sourceMappingURL=test-tubes.js.map
